import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getConfig } from 'services/store/features/Config/actions';

import { useEffect } from 'react';
import Navigation from './components/Navigation';
import RouteConfig from './routes/routes';
import { ErrorBoundary } from 'react-error-boundary';
import { logError } from "utils/logs";


import './components/library/style/normalize.css';
import './components/library/style/reset.css';
import './components/library/style/typography.css';
import './components/library/style/animation.css';

import Toasts from './components/library/Toasts';
import type { AppDispatch, RootState } from 'services/store/types';
import type { ConfigState } from 'services/store/features/Config/types';

interface Props {
  config: ConfigState;
  actions: {
    getConfig: () => void;
  }
}

function App({ config, actions }: Props) {
  useEffect(() => {
    if (config.status === 'IDLE') actions.getConfig();
  }, [config.status]);

  return (
    <div className="App">
      <ErrorBoundary fallback={<div>Something went wrong.</div>} onError={logError}>
        <header>
          <Navigation />
        </header>
        <RouteConfig />
        <Toasts />
      </ErrorBoundary>
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  config: state.config,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators({ getConfig }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
